import { Record } from 'immutable';

export const mkAccountsBalance = Record({
  id: undefined,
  clientId: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  accountId: undefined,
  balanceType: undefined,
  balanceAmount: undefined,
  balanceAt: undefined,
  balanceOn: undefined,
  isDeleted: undefined,
});

export const BalanceTotalsImmutable = Record({
  balanceChange: undefined,
  balanceToday: undefined,
  percentChange: undefined,
});
